import classNames from "classnames";

import {SearchComboboxChevronRightIcon} from "../icons/SearchComboboxChevronRightIcon";
import type {ISearchComboboxShowMoreProps} from "../types/ISearchComboboxShowMoreProps";
import {SearchComboboxSpinner} from "./SearchComboboxSpinner";

import * as styles from "./SearchComboboxShowMore.module.css";

/** "Pokaż więcej ulic (27)" / "Pokaż wszystkie numery (86)"; the spinner replaces the chevron while loading. */
export const SearchComboboxShowMore = (props: ISearchComboboxShowMoreProps) => {
    const {label, isLoading, indent, isActive, className, dataTestId, ...optionProps} = props;
    const isActiveResolved = isActive ?? optionProps["aria-selected"] === true;

    return (
        <div
            role="option"
            aria-selected={false}
            {...optionProps}
            aria-busy={isLoading || undefined}
            className={classNames(styles.showMore, indent && styles.showMoreIndent, isActiveResolved && styles.showMoreActive, className)}
            data-testid={dataTestId}
        >
            <span className={styles.label}>{label}</span>
            {isLoading ? <SearchComboboxSpinner size={16} /> : <SearchComboboxChevronRightIcon size={16} className={styles.chevron} />}
        </div>
    );
};
import classNames from "classnames";

import {SearchComboboxChevronRightIcon} from "../icons/SearchComboboxChevronRightIcon";
import type {ISearchComboboxShowMoreProps} from "../types/ISearchComboboxShowMoreProps";
import {SearchComboboxSpinner} from "./SearchComboboxSpinner";

import * as styles from "./SearchComboboxShowMore.module.css";

/** "Pokaż więcej ulic (27)" / "Pokaż wszystkie numery (86)"; the spinner replaces the chevron while loading. */
export const SearchComboboxShowMore = (props: ISearchComboboxShowMoreProps) => {
    const {label, isLoading, indent, isActive, className, dataTestId, ...optionProps} = props;
    const isActiveResolved = isActive ?? optionProps["aria-selected"] === true;

    return (
        <div
            role="option"
            aria-selected={false}
            {...optionProps}
            aria-busy={isLoading || undefined}
            className={classNames(styles.showMore, indent && styles.showMoreIndent, isActiveResolved && styles.showMoreActive, className)}
            data-testid={dataTestId}
        >
            <span className={styles.label}>{label}</span>
            {isLoading ? <SearchComboboxSpinner size={16} /> : <SearchComboboxChevronRightIcon size={16} className={styles.chevron} />}
        </div>
    );
};
